import { connect } from 'react-redux';

import { closeModal } from '../../../store/modals/actions';
import AiAssistantModal from '../organisms/aIAssistantModal';
import { createObject } from '../../../store/Instance/Actions';
import { InstanceType } from '../../../store/Instances/Instances';
import { getIsOpen, getModalParams } from '../../../store/modals/selectors';

import type { RootState } from '../../../store';

const mapStateToProps = (state: RootState) => ({
  visible: getIsOpen(state),
  params: getModalParams(state),
  newContent: state.instance[InstanceType.JOB_AI_ENHANCEMENT]?.data || {},
  loading: state.instance[InstanceType.JOB_AI_ENHANCEMENT]?.loading || false
});

const mapDispatchToProps = (dispatch: any) => ({
  onClose: () => dispatch(closeModal()),
  getAiEnhancement: (jobId: string, jobDescription: string) => dispatch(createObject({
    instanceType: InstanceType.JOB_AI_ENHANCEMENT,
    dynamicUrlData: `/${jobId}/GenerateJobDescription`,
    data: {
        ContentHTML: jobDescription
    }
  }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiAssistantModal); 